import React, { Component } from "react";
import PropTypes from 'prop-types';
import { Col, Row} from "reactstrap";

import { metadataService, AccountAPI } from "../../_services";
import {  SlButton } from "../editors";
import { MfaCodeEntry } from "../editors/MfaCodeEntry";

export class MfaEmailConfirm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      currentStep: 0,
      mfaCode: ['',''],
      mfaSentMessage: "",
      mfaToken: "", 
      mfaError:""
    };
    this.mfaValueUpdated = this.mfaValueUpdated.bind(this);
    this.confirmSendMfaEmail = this.confirmSendMfaEmail.bind(this);
    this.validateMfaCode = this.validateMfaCode.bind(this);
  }
  confirmSendMfaEmail() {
    //Send the confirmation
    AccountAPI.sendMfaCodeToUserEmail(
      AccountAPI.MFA_REASON_AUTHORIZE_OPERATION
    ).then(response => {
      this.setState({
        mfaToken: response.data.tokenId,
        mfaSentMessage: response.message
      });
    });
  }
  mfaValueUpdated(newMfaValue){
      this.setState({mfaCode:newMfaValue});
  }

  validateMfaCode()
  {
      AccountAPI.validateMfaCode(this.state.mfaToken, this.state.mfaCode, AccountAPI.MFA_REASON_AUTHORIZE_OPERATION)
        .then(
            response => {
                if(response.status <= 1){
                    this.props.mfaConfirmed(this.state.mfaToken);
                }
                else{
                    this.setState({mfaError:response.message});
                }
            }
        )
  }
  render() {
    if (this.state.mfaToken === "") {
      //Get Token
      return (
        <React.Fragment>
          <Row className="justify-content-center">
            <Col xs={12} md={6}>
              {metadataService.getMessage("MfaWillConfirmEmail")}
            </Col>
          </Row>
          <Row className="justify-content-center">
              <SlButton name="OK" onClick={this.confirmSendMfaEmail} />
          </Row>
        </React.Fragment>
      );
    } // Validate Token
    else {
      return (
          <MfaCodeEntry message={this.state.mfaSentMessage} value={this.state.mfaCode} 
            valueUpdated={this.mfaValueUpdated} onSubmit={this.validateMfaCode} error={this.state.mfaError}/>
      );
    }
  }
}
MfaEmailConfirm.propTypes = {
    mfaConfirmed: PropTypes.func.isRequired 
}